<template>
  <header class="n4-cabecera" v-if="NOTARIA?.Theme">
    <!-- Línea de fecha, como en la cabecera de un periódico -->
    <div class="n4-fecha">
      <div class="n2-contenedor n4-fecha__fila">
        <span class="n4-fecha__dia">{{ hoy }}</span>
        <span v-if="estado !== null" class="n2-estado" :class="estado ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
          <span class="n2-estado__punto"></span>{{ tSolicitud(estado ? 'Abierto ahora' : 'Cerrado ahora') }}
        </span>
        <span class="n4-fecha__datos">
          <a v-if="C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')"><v-icon size="16">mdi-phone-outline</v-icon> {{ C.Telefono.trim() }}</a>
          <span v-if="C.Municipio" class="n4-solo-escritorio"><v-icon size="16">mdi-map-marker-outline</v-icon> {{ C.Municipio }}</span>
        </span>
      </div>
    </div>

    <!-- Cabecera con el logo y el nombre -->
    <div class="n2-contenedor n4-mancheta">
      <NuxtLink v-if="T.Menu?.Logo" :to="getLocalePath('/')" class="n4-logo" tabindex="-1" aria-hidden="true">
        <img :src="imagenIDtoSRC(T.Menu.Logo)" alt="" />
      </NuxtLink>
      <NuxtLink :to="getLocalePath('/')" class="n4-logo__nombre">{{ NOTARIA.Nombre }}</NuxtLink>
      <div class="n4-mancheta__acciones">
        <button v-if="NOTARIA.Personalizar?.Accesibilidad" type="button" class="n2-icono" @click="store.toggleModoAccesible"
          :aria-label="$t(store.ModoAccesible ? 'DesactivarModoAccesibilidad' : 'ActivarModoAccesibilidad')">
          <v-icon>mdi-human</v-icon>
        </button>
        <v-menu v-if="NOTARIA.Personalizar?.Multilenguaje && idiomas.length > 1">
          <template v-slot:activator="{ props }">
            <button type="button" class="n2-icono" v-bind="props" :aria-label="$t('seleccionIdioma')">
              <IconoIdioma :flag="store.getFlag" />
            </button>
          </template>
          <v-list density="compact">
            <v-list-item v-for="i in idiomas" :key="i.Language" @click="cambiarIdioma(i)" :title="i.Title">
              <template v-slot:prepend><IconoIdioma :flag="i.Flag" class="mr-2" /></template>
            </v-list-item>
          </v-list>
        </v-menu>
        <button type="button" class="n2-icono n4-solo-movil" :aria-expanded="abierto" aria-controls="n4-menu" aria-label="Menú" @click="abierto = !abierto">
          <v-icon>{{ abierto ? 'mdi-close' : 'mdi-menu' }}</v-icon>
        </button>
      </div>
    </div>

    <!-- Menú entre filetes; en móvil, desplegable -->
    <nav id="n4-menu" class="n4-nav" :class="{ 'n4-nav--abierto': abierto }" :aria-label="$t('Inicio')">
      <div class="n2-contenedor n4-nav__fila">
        <template v-for="e in enlaces" :key="e.clave">
          <a v-if="e.externo" :href="e.href" target="_blank" rel="noopener">{{ e.texto }}</a>
          <NuxtLink v-else :to="e.to" @click="abierto = false">{{ e.texto }}</NuxtLink>
        </template>
        <NuxtLink v-if="acceso.visible('menu')" :to="acceso.enlace('menu')" class="n4-nav__encargo" @click="abierto = false">
          {{ tSolicitud('Encargo online') }} →
        </NuxtLink>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud, idiomaSolicitud } from '../../composables/solicitudTextos'
import { useMenuNotaria, abiertoAhora } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()
const route = useRoute()
const { enlaces, idiomas, cambiarIdioma } = useMenuNotaria()

const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const abierto = ref(false)

// La fecha y el estado dependen de la hora del visitante: solo en el navegador
const hoy = ref('')
const estado = ref(null)
watch(() => route.fullPath, () => { abierto.value = false })

onMounted(() => {
  hoy.value = new Date().toLocaleDateString(idiomaSolicitud.value, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Madrid' })
  estado.value = abiertoAhora(C.value.HorarioEstructurado)
})
</script>
